// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class FaultLogResponse implements flatbuffers.IUnpackableObject<FaultLogResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FaultLogResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFaultLogResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FaultLogResponse,
  ): FaultLogResponse {
    return (obj || new FaultLogResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFaultLogResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FaultLogResponse,
  ): FaultLogResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FaultLogResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  liftName(): string;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  liftName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  cleared(): string | null;
  cleared(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cleared(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  floor(): string | null;
  floor(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  floor(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fault(): string | null;
  fault(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fault(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  detailedFault(): string | null;
  detailedFault(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  detailedFault(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  direction(): string | null;
  direction(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  direction(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startFaultLogResponse(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, liftNameOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dateOffset, 0);
  }

  static addCleared(builder: flatbuffers.Builder, clearedOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, clearedOffset, 0);
  }

  static addFloor(builder: flatbuffers.Builder, floorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, floorOffset, 0);
  }

  static addFault(builder: flatbuffers.Builder, faultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, faultOffset, 0);
  }

  static addDetailedFault(builder: flatbuffers.Builder, detailedFaultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, detailedFaultOffset, 0);
  }

  static addDirection(builder: flatbuffers.Builder, directionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, directionOffset, 0);
  }

  static endFaultLogResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // lift_name
    builder.requiredField(offset, 6); // date
    return offset;
  }

  static createFaultLogResponse(
    builder: flatbuffers.Builder,
    liftNameOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    clearedOffset: flatbuffers.Offset,
    floorOffset: flatbuffers.Offset,
    faultOffset: flatbuffers.Offset,
    detailedFaultOffset: flatbuffers.Offset,
    directionOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    FaultLogResponse.startFaultLogResponse(builder);
    FaultLogResponse.addLiftName(builder, liftNameOffset);
    FaultLogResponse.addDate(builder, dateOffset);
    FaultLogResponse.addCleared(builder, clearedOffset);
    FaultLogResponse.addFloor(builder, floorOffset);
    FaultLogResponse.addFault(builder, faultOffset);
    FaultLogResponse.addDetailedFault(builder, detailedFaultOffset);
    FaultLogResponse.addDirection(builder, directionOffset);
    return FaultLogResponse.endFaultLogResponse(builder);
  }

  unpack(): FaultLogResponseT {
    return new FaultLogResponseT(
      this.liftName(),
      this.date(),
      this.cleared(),
      this.floor(),
      this.fault(),
      this.detailedFault(),
      this.direction(),
    );
  }

  unpackTo(_o: FaultLogResponseT): void {
    _o.liftName = this.liftName();
    _o.date = this.date();
    _o.cleared = this.cleared();
    _o.floor = this.floor();
    _o.fault = this.fault();
    _o.detailedFault = this.detailedFault();
    _o.direction = this.direction();
  }

  unpackFields(...fields: string[]): FaultLogResponseT {
    const t = new FaultLogResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("cleared")) {
      t.cleared = this.cleared();
    }
    if (fieldSet.has("floor")) {
      t.floor = this.floor();
    }
    if (fieldSet.has("fault")) {
      t.fault = this.fault();
    }
    if (fieldSet.has("detailed_fault")) {
      t.detailedFault = this.detailedFault();
    }
    if (fieldSet.has("direction")) {
      t.direction = this.direction();
    }
    return t;
  }
}

export class FaultLogResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public liftName: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public cleared: string | Uint8Array | null = null,
    public floor: string | Uint8Array | null = null,
    public fault: string | Uint8Array | null = null,
    public detailedFault: string | Uint8Array | null = null,
    public direction: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.liftName === null || this.liftName === undefined) {
      throw new Error('Required field "lift_name" is not set');
    }
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const cleared = this.cleared !== null ? builder.createString(this.cleared!) : 0;
    const floor = this.floor !== null ? builder.createString(this.floor!) : 0;
    const fault = this.fault !== null ? builder.createString(this.fault!) : 0;
    const detailedFault =
      this.detailedFault !== null ? builder.createString(this.detailedFault!) : 0;
    const direction = this.direction !== null ? builder.createString(this.direction!) : 0;

    return FaultLogResponse.createFaultLogResponse(
      builder,
      liftName,
      date,
      cleared,
      floor,
      fault,
      detailedFault,
      direction,
    );
  }

  clone(): FaultLogResponseT {
    const obj = new FaultLogResponseT();
    obj.liftName = this.liftName;
    obj.date = this.date;
    obj.cleared = this.cleared;
    obj.floor = this.floor;
    obj.fault = this.fault;
    obj.detailedFault = this.detailedFault;
    obj.direction = this.direction;
    return obj;
  }

  equals(other: FaultLogResponseT): boolean {
    if (this.liftName !== other.liftName) return false;
    if (this.date !== other.date) return false;
    if (this.cleared !== other.cleared) return false;
    if (this.floor !== other.floor) return false;
    if (this.fault !== other.fault) return false;
    if (this.detailedFault !== other.detailedFault) return false;
    if (this.direction !== other.direction) return false;
    return true;
  }
}

export function verifyFaultLogResponse(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "lift_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
